import React, { useState, useEffect, useRef } from 'react';
import CardSwap, { Card } from './CardSwap';// 👇 加上这一行，把视频当做一个模块引进来
import avatarVideo from './avatar.mp4';
import GradientText from './GradientText';
import BlurText from './BlurText';
import Beams from './Beams';
import BorderGlow from './BorderGlow';
import PixelCard from './PixelCard';
import VfxPortfolio from './VfxPortfolio';
import ColorGradingPortfolio from './ColorGradingPortfolio';
import VisualDesignPortfolio from './VisualDesignPortfolio';
import ContactPortfolio from './ContactPortfolio';

// ================== 组件：第3屏核心作品轮播图 ==================
function CoreWorksCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // 模拟6张核心作品的数据 (后续可替换为你真实的图片URL和标题)
  const works = [
    { id: 1, title: '甄嬛联名礼物玩法', bgColor: 'bg-rose-100' },
    { id: 2, title: '传说商店荣誉出口', bgColor: 'bg-blue-100' },
    { id: 3, title: '宫格PK赏金赛', bgColor: 'bg-purple-100' },
    { id: 4, title: '拾光成芒', bgColor: 'bg-amber-100' },
    { id: 5, title: '核心项目 5', bgColor: 'bg-emerald-100' },
    { id: 6, title: '核心项目 6', bgColor: 'bg-cyan-100' },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === works.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? works.length - 1 : prevIndex - 1));
  };

  return (
    <div className="relative w-full aspect-video md:aspect-[21/9] rounded-2xl overflow-hidden shadow-sm border border-gray-200 group">
      {/* 轮播轨道 */}
      <div 
        className="flex h-full transition-transform duration-500 ease-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {works.map((work) => (
          <div key={work.id} className={`min-w-full h-full flex flex-col items-center justify-center ${work.bgColor}`}>
            <span className="text-2xl font-bold text-gray-700">{work.title}</span>
            <span className="text-gray-500 mt-2">[ 核心作品图片占位 ]</span>
          </div>
        ))}
      </div>

      {/* 左侧控制按钮 */}
      <button 
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/80 backdrop-blur rounded-full shadow-md hover:bg-white flex items-center justify-center transition opacity-0 group-hover:opacity-100 focus:opacity-100"
      >
        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path></svg>
      </button>

      {/* 右侧控制按钮 */}
      <button 
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/80 backdrop-blur rounded-full shadow-md hover:bg-white flex items-center justify-center transition opacity-0 group-hover:opacity-100 focus:opacity-100"
      >
        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
      </button>

      {/* 底部指示点 */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {works.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2.5 h-2.5 rounded-full transition-colors ${currentIndex === index ? 'bg-gray-800' : 'bg-gray-400/50 hover:bg-gray-600'}`}
          />
        ))}
      </div>
    </div>
  );
}


// ================== 主页面：5屏布局 ==================
export default function App() {
  
  const [showName, setShowName] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const galleryItems = [1, 2, 3, 4, 5, 6, 7, 8];
  // 💡 新增：记录当前这一屏是否在屏幕内
  const [isVisible, setIsVisible] = useState(false); 
  const sectionRef = useRef(null); // 这是一个绑在第二屏的“物理探头”
  // 💡 【新增】：超高性能的“全局聚光灯”鼠标追踪雷达
  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    e.currentTarget.style.setProperty('--mouse-x', `${x}px`);
    e.currentTarget.style.setProperty('--mouse-y', `${y}px`);
  };
// 💡 新增：当前展示的页面状态 ('home' 代表主页, 'vfx' 代表特效页)
  const [currentPage, setCurrentPage] = useState('home');
  // 1. 监听是否滑到了这一屏 (露出 40% 就触发)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.4 } 
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // 2. 智能时间轴：滑到就按顺序播放，滑走就重置！
  useEffect(() => {
    let timer;
    if (isVisible) {
      setShowName(false); // 确保一开始隐藏“王涛”
      timer = setTimeout(() => {
        setShowName(true); // 1.5秒后放出“王涛”
      }, 800); 
    } else {
      setShowName(false); // 💡 离开视口时重置，这样下次滑回来又能重新看一遍！
    }
    return () => clearTimeout(timer);
  }, [isVisible]);
 // 第3屏入场动画专属 State 和 Ref
  const [isSection3Visible, setIsSection3Visible] = useState(false);
  const section3Ref = useRef(null);

  // 💡 【新增这一行】：控制“卡片放大进入中心”的传送门数据
  const [activePortal, setActivePortal] = useState(null);
// 💡 新增：控制跳转过渡动画的状态
  const [isNavigating, setIsNavigating] = useState(false);

  // 💡 新增：点击巨幕后的酷炫跳转逻辑
  const handleProjectJump = () => {
    setIsNavigating(true); 
    
    setTimeout(() => {
      
      // 🚀 覆盖后的新逻辑：特效、影视、视觉全部打通！
      if (activePortal?.title?.includes('特效')) {
        setCurrentPage('vfx');
      } else if (activePortal?.title?.includes('影视')) {
        setCurrentPage('colorGrading'); 
      } else if (activePortal?.title?.includes('视觉')) {
        // 🌟 新增的视觉设计 VIP 通道！
        setCurrentPage('visualDesign'); 
      } else {
        alert(`当前点击：【${activePortal?.title}】\n该页面还在玩命开发中...`);
      }
      
      setIsNavigating(false);
      setActivePortal(null); 
      
    }, 800);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsSection3Visible(true);  // 滑入视野，触发入场
        } else {
          setIsSection3Visible(false); // 划走时重置！这样每次回来都会重新播放！
        }
      },
      { threshold: 0.2 } // 露出 20% 时就开始动画
    );

    if (section3Ref.current) {
      observer.observe(section3Ref.current);
    }

    return () => {
      if (section3Ref.current) observer.unobserve(section3Ref.current);
    };
  }, []); 
  // =====================================================================
  // 🎨 满血动态版：三大核心业务视觉组件 (修复错位 + 注入工作流动画)
  // =====================================================================

  // 1. 【视觉设计】主题：动态律动的贝塞尔曲线
  const VisualDesignContent = (
    <div className="w-full h-full bg-[#0a0a0c] flex flex-col items-center justify-center relative overflow-hidden transition-transform duration-1000 group-hover/video:scale-105">
      <div className="absolute inset-0 bg-[radial-gradient(rgba(59,130,246,0.15)_1px,transparent_1px)] bg-[size:30px_30px]"></div>
      
      <div className="relative z-10 w-full max-w-[800px] h-[400px]">
        <svg className="w-full h-full overflow-visible" viewBox="0 0 800 400">
          
          {/* 左侧控制线 */}
          <line x1="150" y1="250" x2="300" stroke="#3b82f6" strokeWidth="2" strokeDasharray="6 6" className="opacity-50">
             <animate attributeName="y2" values="80; 200; 80" dur="4s" repeatCount="indefinite" ease="ease-in-out"/>
          </line>
          
          {/* 右侧控制线 */}
          <line x1="650" y1="150" x2="500" stroke="#3b82f6" strokeWidth="2" strokeDasharray="6 6" className="opacity-50">
             <animate attributeName="y2" values="320; 200; 320" dur="4s" repeatCount="indefinite" ease="ease-in-out"/>
          </line>
          
          {/* 核心动态曲线 */}
          <path fill="none" stroke="#60a5fa" strokeWidth="6" strokeLinecap="round" className="drop-shadow-[0_0_15px_rgba(96,165,250,0.8)]">
            <animate attributeName="d" values="M 150 250 C 300 80, 500 320, 650 150; M 150 250 C 300 200, 500 200, 650 150; M 150 250 C 300 80, 500 320, 650 150" dur="4s" repeatCount="indefinite" ease="ease-in-out"/>
          </path>
          
          {/* 固定的端点 */}
          <rect x="144" y="244" width="12" height="12" fill="#0a0a0c" stroke="#60a5fa" strokeWidth="3" />
          <rect x="644" y="144" width="12" height="12" fill="#0a0a0c" stroke="#60a5fa" strokeWidth="3" />

          {/* 动态的控制点 (圆圈) */}
          <circle cx="300" r="6" fill="#fff" filter="drop-shadow(0 0 10px #3b82f6)">
             <animate attributeName="cy" values="80; 200; 80" dur="4s" repeatCount="indefinite" ease="ease-in-out"/>
          </circle>
          <circle cx="500" r="6" fill="#fff" filter="drop-shadow(0 0 10px #3b82f6)">
             <animate attributeName="cy" values="320; 200; 320" dur="4s" repeatCount="indefinite" ease="ease-in-out"/>
          </circle>
        </svg>
      </div>

      <div className="absolute bottom-10 flex gap-4 bg-neutral-900/80 backdrop-blur-md border border-white/10 px-6 py-3 rounded-full shadow-2xl">
        <div className="text-blue-400 font-mono text-sm tracking-widest font-bold">PEN TOOL</div>
        <div className="w-[1px] h-5 bg-white/20"></div>
        <div className="text-neutral-400 font-mono text-sm">VECTOR_PATH_ANIMATED</div>
      </div>
    </div>
  );

  // 2. 【特效制作】主题：绝对像素锁定（彻底修复节点断线），恢复长方形动画
  const VFXContent = (
    <div className="w-full h-full bg-[#050907] flex flex-col items-center justify-center relative overflow-hidden transition-transform duration-1000 group-hover/video:scale-105 p-8 gap-10">
       
       {/* 顶部：长方形追踪画面（恢复旋转动画） */}
       <div className="w-full h-[280px] max-w-[900px] shrink-0 border border-emerald-500/20 bg-emerald-900/10 rounded-lg relative overflow-hidden flex items-center justify-center shadow-[0_0_50px_rgba(16,185,129,0.05)]">
          <div className="absolute top-6 left-6 w-10 h-10 border-t-2 border-l-2 border-emerald-500/60"></div>
          <div className="absolute top-6 right-6 w-10 h-10 border-t-2 border-r-2 border-emerald-500/60"></div>
          <div className="absolute bottom-6 left-6 w-10 h-10 border-b-2 border-l-2 border-emerald-500/60"></div>
          <div className="absolute bottom-6 right-6 w-10 h-10 border-b-2 border-r-2 border-emerald-500/60"></div>
          
          {/* 嵌套旋转动画 */}
          <div className="w-[200px] h-[200px] border-2 border-emerald-500/30 rounded-full animate-[spin_8s_linear_infinite] border-dashed flex items-center justify-center">
             <div className="w-[100px] h-[100px] border border-emerald-500/20 rounded-full animate-[spin_4s_linear_infinite_reverse]"></div>
          </div>
       </div>

       {/* 底部：节点树（🚨核心修复：锁死宽高 800x200，SVG和DOM坐标100%强制绑定） */}
       <div className="relative w-[800px] h-[200px] shrink-0">
          
          <svg className="absolute inset-0 w-full h-full z-0 pointer-events-none" viewBox="0 0 800 200">
             {/* 左侧连线：一实一虚流动，精准插入节点正上方 */}
             <path d="M 200 40 C 200 100, 400 100, 400 140" fill="none" stroke="#10b981" strokeWidth="2" strokeDasharray="8 6" opacity="0.8">
                <animate attributeName="stroke-dashoffset" from="14" to="0" dur="0.5s" repeatCount="indefinite" />
             </path>
             {/* 右侧连线：一实一虚流动，精准插入节点正上方 */}
             <path d="M 600 40 C 600 100, 400 100, 400 140" fill="none" stroke="#10b981" strokeWidth="2" strokeDasharray="8 6" opacity="0.8">
                <animate attributeName="stroke-dashoffset" from="14" to="0" dur="0.5s" repeatCount="indefinite" />
             </path>
          </svg>
          
          {/* 绝对定位节点：完全贴合上面的 SVG 坐标 */}
          <div className="absolute top-[20px] left-[100px] w-[200px] h-[40px] flex items-center justify-center bg-neutral-900 border border-neutral-700 rounded text-emerald-500 font-mono text-sm tracking-widest shadow-[0_0_15px_rgba(16,185,129,0.1)] z-10">
             3D_Tracker
          </div>
          
          <div className="absolute top-[20px] left-[500px] w-[200px] h-[40px] flex items-center justify-center bg-neutral-900 border border-neutral-700 rounded text-blue-400 font-mono text-sm tracking-widest z-10">
             Keylight
          </div>
          
          <div className="absolute top-[140px] left-[280px] w-[240px] h-[44px] flex items-center justify-center bg-emerald-950 border-2 border-emerald-500 rounded text-white font-mono text-sm tracking-widest shadow-[0_0_30px_rgba(16,185,129,0.4)] z-10">
             MERGE_RENDER_OUT
          </div>
       </div>
    </div>
  );

  // 3. 【影视制作】主题：防 3D 遮挡，调色盘居左，时间码居右
  const ColorGradingContent = (
    <div className="w-full h-full bg-[#0a0a0a] flex flex-col relative overflow-hidden transition-transform duration-1000 group-hover/video:scale-105 p-8 gap-6">
      
      <style>{`
        @keyframes scanTimeline { 0% { left: 10%; } 100% { left: 85%; } }
        .animate-playhead { animation: scanTimeline 4s ease-in-out infinite alternate; }
      `}</style>

      {/* 顶部监视器 */}
      <div className="w-full h-[280px] shrink-0 bg-black border border-white/10 rounded shadow-[0_20px_50px_rgba(0,0,0,0.8)] relative overflow-hidden flex items-end justify-end p-4">
         <div className="absolute inset-0 bg-gradient-to-tr from-teal-900 via-neutral-900 to-orange-900 opacity-80 mix-blend-screen"></div>
         <span className="relative z-10 font-mono text-sm tracking-[0.2em] text-orange-400/80">REC.709 CINEMATIC</span>
      </div>

      {/* 中部：【核心修改】调色盘在左，时间码在右 */}
      <div className="w-full h-[100px] shrink-0 flex justify-between items-center px-4">
         
         {/* 移到左侧：三大调色色轮，现在完美展示在最前方 */}
         <div className="flex gap-10 relative z-10">
            {/* LIFT */}
            <div className="flex flex-col items-center gap-2">
               <div className="w-16 h-16 rounded-full border-[4px] border-neutral-800 relative bg-[conic-gradient(#fca5a5,#fef08a,#86efac,#67e8f9,#93c5fd,#d8b4fe,#fca5a5)] opacity-80 shadow-inner flex items-center justify-center">
                  <div className="absolute w-3 h-3 bg-neutral-900 rounded-full"></div>
                  <div className="absolute w-2 h-2 bg-white rounded-full translate-x-3 translate-y-2 shadow-[0_0_5px_rgba(0,0,0,0.8)]"></div>
               </div>
               <span className="text-[10px] text-neutral-400 font-mono tracking-widest">LIFT</span>
            </div>
            {/* GAMMA */}
            <div className="flex flex-col items-center gap-2">
               <div className="w-16 h-16 rounded-full border-[4px] border-neutral-800 relative bg-[conic-gradient(#fca5a5,#fef08a,#86efac,#67e8f9,#93c5fd,#d8b4fe,#fca5a5)] opacity-80 shadow-inner flex items-center justify-center">
                  <div className="absolute w-3 h-3 bg-neutral-900 rounded-full"></div>
                  <div className="absolute w-2 h-2 bg-white rounded-full -translate-x-3 -translate-y-2 shadow-[0_0_5px_rgba(0,0,0,0.8)]"></div>
               </div>
               <span className="text-[10px] text-neutral-400 font-mono tracking-widest">GAMMA</span>
            </div>
            {/* GAIN */}
            <div className="flex flex-col items-center gap-2">
               <div className="w-16 h-16 rounded-full border-[4px] border-neutral-800 relative bg-[conic-gradient(#fca5a5,#fef08a,#86efac,#67e8f9,#93c5fd,#d8b4fe,#fca5a5)] opacity-80 shadow-inner flex items-center justify-center">
                  <div className="absolute w-3 h-3 bg-neutral-900 rounded-full"></div>
                  <div className="absolute w-2 h-2 bg-white rounded-full translate-x-2 -translate-y-3 shadow-[0_0_5px_rgba(0,0,0,0.8)]"></div>
               </div>
               <span className="text-[10px] text-neutral-400 font-mono tracking-widest">GAIN</span>
            </div>
         </div>

         {/* 移到右侧：大号时间码，藏在透视远端依然很有氛围感 */}
         <span className="font-mono text-4xl font-light tracking-[0.1em] text-orange-500/90 text-right">
            01:04:23<span className="text-orange-500/50 animate-pulse">:18</span>
         </span>

      </div>

      {/* 底部：多轨道剪辑时间线 */}
      <div className="flex-1 w-full bg-neutral-900/50 border border-white/10 rounded-lg p-4 relative flex flex-col justify-center gap-3">
         <div className="absolute top-0 bottom-0 w-[2px] bg-orange-500 z-20 shadow-[0_0_15px_rgba(249,115,22,1)] animate-playhead">
            <div className="w-4 h-4 bg-orange-500 rounded-sm -ml-[7px] mt-1 shadow-[0_0_10px_rgba(249,115,22,0.8)]"></div>
         </div>
         <div className="w-full h-8 bg-neutral-800/50 rounded flex items-center px-2 border-b border-white/5 relative overflow-hidden">
            <div className="absolute left-[15%] w-[20%] h-6 bg-purple-600/60 rounded-sm border border-purple-400/30"></div>
         </div>
         <div className="w-full h-10 bg-neutral-800/80 rounded flex items-center px-2 border-b border-white/5 relative overflow-hidden">
            <div className="absolute left-[5%] w-[30%] h-7 bg-blue-600/60 rounded-sm border border-blue-400/30"></div>
            <div className="absolute left-[40%] w-[45%] h-7 bg-teal-600/60 rounded-sm border border-teal-400/30"></div>
         </div>
         <div className="w-full h-10 bg-neutral-800/80 rounded flex items-center px-2 relative overflow-hidden">
            <div className="absolute left-[10%] w-[15%] h-7 bg-blue-700/60 rounded-sm border border-blue-400/30"></div>
            <div className="absolute left-[30%] w-[60%] h-7 bg-blue-600/60 rounded-sm border border-blue-400/30"></div>
         </div>
      </div>
    </div>
  );
// ... 上面是你写的 ColorGradingContent 影视制作画作代码 ...

  // ==========================================================
  // 👇 把第四步的代码贴在这里！（在原本的 return 的正上方）
  // ==========================================================
  

  // 💡 【这里就是你原本就有的 return 标签，保留它不动】
  // return (
  //   <div className="h-screen overflow-y-auto ...">

  return (
  
    <div className="h-screen overflow-y-auto snap-y snap-mandatory bg-[#030208] text-white scroll-smooth font-sans relative z-0">
      
      {/* 🚀 新增：高端极简氛围背景层（深紫与暗蓝的微妙交织） */}
      <div className="fixed inset-0 z-[-1] pointer-events-none overflow-hidden">
        {/* 左上角深紫色柔光 */}
        <div className="absolute -top-[20%] -left-[10%] w-[70vw] h-[70vw] rounded-full bg-purple-900/20 blur-[130px] opacity-60"></div>
        {/* 右下角深蓝色柔光 */}
        <div className="absolute -bottom-[20%] -right-[10%] w-[80vw] h-[80vw] rounded-full bg-blue-900/20 blur-[150px] opacity-60"></div>
        {/* 屏幕中央的极弱环境光 */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[100vw] h-[50vh] bg-indigo-900/10 blur-[100px] pointer-events-none"></div>
      </div>

      {/* --- 原本的特效覆盖层代码从这里开始（{currentPage === 'vfx' ...），不要动它们 --- */}

     {/* ========================================================= */}
      {/* 🚀 核心修复：将特效页作为绝对定位的“全屏图层”盖在主页最上方 */}
      {/* 这样主页的滚动位置和动画状态将得到 100% 完美的保留！ */}
      {/* ========================================================= */}
      {currentPage === 'vfx' && (
        <div className="fixed inset-0 z-[999]  overflow-y-auto animate-[fadeIn_0.5s_ease-out]">
          <VfxPortfolio onBack={() => setCurrentPage('home')} />
        </div>
      )} 

      {/* 之前加的特效制作覆盖层 */}
      {currentPage === 'vfx' && (
        <div className="fixed inset-0 z-[999]  overflow-y-auto animate-[fadeIn_0.5s_ease-out]">
          <VfxPortfolio onBack={() => setCurrentPage('home')} />
        </div>
      )}

      {/* 影视调色覆盖层 */}
      {currentPage === 'colorGrading' && (
        // 🚀 核心：一定要确保这里写的是 overflow-y-auto，绝对不能有 overflow-hidden
        <div className="fixed inset-0 z-[999]  overflow-y-auto animate-[fadeIn_0.5s_ease-out]">
          <ColorGradingPortfolio onBack={() => setCurrentPage('home')} />
        </div>
      )}
      // 2. 找到之前的覆盖层代码，在它们下面加上这个视觉设计覆盖层：
      {currentPage === 'visualDesign' && (
        <div className="fixed inset-0 z-[999]  overflow-y-auto animate-[fadeIn_0.5s_ease-out]">
          <VisualDesignPortfolio onBack={() => setCurrentPage('home')} />
        </div>
      )}
      
      
      {/* 第1屏：3D 动态射线背景 */}
      <section className="relative h-screen w-full snap-start flex flex-col items-center justify-center  overflow-hidden">
        
        {/* 强制要求这个背景容器占据 100vw（屏幕全宽）和 100vh（屏幕全高） */}
        <div className="absolute top-0 left-0 w-[100vw] h-[100vh] z-0 overflow-hidden">
  <Beams 
    beamWidth={3}
    beamHeight={30}
    beamNumber={20}
    lightColor="#cbe6ff"
    speed={2}
    noiseIntensity={1.75}
    scale={0.2}
    rotation={30}
  />
</div>

        
        {/* 前景内容层：放在 3D 背景之上 (z-10) */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full w-full pointer-events-none">
          
          {/* 1. 顶部极简导航栏 */}
          <nav className="absolute top-0 w-full px-8 py-8 flex justify-between items-center pointer-events-auto">
            <div className="text-white font-bold text-xl tracking-widest opacity-90">TAO.</div>
            <div className="flex space-x-8 text-sm text-gray-400 font-light">
              <span className="hover:text-white cursor-pointer transition-colors">关于</span>
              <span className="hover:text-white cursor-pointer transition-colors">作品</span>
              <span className="hover:text-white cursor-pointer transition-colors">联系</span>
            </div>
          </nav>

          {/* 2. 状态徽章 (毛玻璃 + 呼吸灯) */}
          <div className="mb-6 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md flex items-center space-x-3 pointer-events-auto shadow-lg">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse shadow-[0_0_8px_rgba(52,211,153,0.8)]"></span>
            <span className="text-[10px] text-gray-300 tracking-[0.2em] font-light">COLLECTION OF WORKS</span>
          </div>

          {/* 3. 主标题与核心技能点缀 */}
          <div className="text-center">
            
           {/* 🚀 终极防弹版：完美复刻原本的颜色与流动特效，绝对不会消失！ */}
          <div className="text-8xl md:text-[170px] font-black tracking-tighter leading-none mb-6 flex justify-center items-center relative z-50">
            <span 
              className="select-none drop-shadow-[0_0_40px_rgba(193,226,255,0.15)]"
              style={{
                /* 完美还原你的三个颜色，并首尾相连形成完美循环 */
                background: 'linear-gradient(to right, #2b5a8d, #c1e2ff, #cfe5f8, #2b5a8d)',
                backgroundSize: '300% 100%',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                animation: 'taoGradientFlow 8s linear infinite'
              }}
            >
              TAO
            </span>
            {/* 内置专属动画引擎，保证平滑流动 */}
            <style>
              {`
                @keyframes taoGradientFlow {
                  0% { background-position: 0% 50%; }
                  100% { background-position: 100% 50%; }
                }
              `}
            </style>
          </div>
            
            <p className="text-sm md:text-base text-gray-400 tracking-[0.3em] font-light mt-4">
              视觉设计 <span className="mx-2 text-blue-500/50">•</span> 影视调色 <span className="mx-2 text-blue-500/50">•</span> 特效制作
            </p>
          </div>

          {/* 4. 侧边悬浮装饰线 (纵向几何排版) */}
          <div className="absolute left-8 bottom-12 flex flex-col items-center pointer-events-auto opacity-50 hover:opacity-100 transition-opacity duration-500">
            <div className="w-[1px] h-16 bg-gradient-to-b from-transparent to-blue-400/50"></div>
            <span className="text-[10px] text-gray-400 tracking-[0.3em] my-6" style={{ writingMode: 'vertical-rl' }}>
              SCROLL DOWN
            </span>
            <div className="w-[1px] h-16 bg-gradient-to-t from-transparent to-blue-400/50"></div>
          </div>

        </div>
        
        
        <div className="absolute bottom-10 animate-bounce text-white opacity-80 cursor-pointer z-10">
          <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </section>
      

      {/* ================= 第2屏：个人介绍 (暗黑科技风) ================= */}
      <section className="h-screen w-full snap-start flex items-center justify-center px-6 md:px-12 bg-[#050505] relative overflow-hidden">
        
        {/* 背景氛围光晕：呼应第一屏的蓝色射线 */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60vw] h-[400px] bg-blue-900/20 blur-[120px] rounded-full pointer-events-none"></div>

        <div ref={sectionRef} className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-24 items-center relative z-10">
          
          {/* 左侧文字介绍：信息层级重构版 */}
         <div className="mt-28 lg:mt-0 space-y-4 lg:space-y-10 scale-[0.8] origin-top lg:scale-100 lg:origin-center">
            
            {/* 标题区：接力顺序出现效果 */}
            <div>
              <div className="flex flex-wrap items-baseline gap-x-4 mb-4">
                {/* 第一段文本：滑到当前页才渲染播放 */}
                {isVisible && (
                  <BlurText
                    text="Hello, 我是"
                    delay={50} 
                    animateBy="letters"
                    direction="top"
                    className="text-4xl md:text-6xl font-bold tracking-tight text-white"
                  />
                )}
                
                {/* 第二段文本：时间轴放行才播放 */}
                {isVisible && showName && (
                  <BlurText
                    text="王涛"
                    delay={50}
                    animateBy="letters"
                    direction="top"
                    className="text-4xl md:text-6xl font-bold tracking-tight text-[#108fff]"
                  />
                )}
              </div>
            </div>

            {/* 👇 💡 魔法在这里：剩余文字的大容器，纯 CSS 控制从下往上渐变浮现 */}
            <div
 className={`pt-2 lg:pt-0 transition-all duration-1000 ease-out transform ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
  }`}
  style={{ transitionDelay: isVisible ? '2200ms' : '0ms' }} // 👈 关键帧延迟：等上方标题播放 2.2 秒后再出场；离开时立刻隐藏重置
>
              
              {/* 你的工作经验 */}
              <p className="text-lg md:text-xl text-gray-400 font-light mb-3 lg:mb-8">
                拥有 <span className="font-bold text-white text-2xl mx-1">4</span> 年设计经验。
              </p>

              {/* 核心优势列表区 */}
              <div className="space-y-3 lg:space-y-6">
                
                {/* 模块 1 */}
                <div className="flex items-start group">
                  <div className="flex-shrink-0 mt-2 mr-4 w-1.5 h-1.5 rounded-full bg-[#108fff] group-hover:scale-150 transition-transform duration-300"></div>
                  <div>
                    <h3 className="text-white font-medium text-lg tracking-widest mb-2">复合型技术栈</h3>
                    <p className="text-sm md:text-base leading-relaxed text-gray-400 font-light">
                      拥有扎实的影视后期与三维设计功底，能够将传统工作流（<span className="text-gray-200 font-normal">C4D / AE / PR / PS / 达芬奇</span>）与最新 AI 生成技术（<span className="text-gray-200 font-normal">ComfyUI / Gemini / 海螺等</span>）完美结合，独立完成从分镜策划、建模渲染到剪辑调色的全链路工作。
                    </p>
                  </div>
                </div>

                {/* 模块 2 */}
                <div className="flex items-start group">
                  <div className="flex-shrink-0 mt-2 mr-4 w-1.5 h-1.5 rounded-full bg-[#108fff] group-hover:scale-150 transition-transform duration-300"></div>
                  <div>
                    <h3 className="text-white font-medium text-lg tracking-widest mb-2">团队管理与协作能力</h3>
                    <p className="text-sm md:text-base leading-relaxed text-gray-400 font-light">
                      具备从一线执行到后期组长的管理经验，能够高效跨部门沟通，合理拆解项目节点，对项目进度和最终视觉质量负责。
                    </p>
                  </div>
                </div>

                {/* 模块 3 */}
                <div className="flex items-start group">
                  <div className="flex-shrink-0 mt-2 mr-4 w-1.5 h-1.5 rounded-full bg-[#108fff] group-hover:scale-150 transition-transform duration-300"></div>
                  <div>
                    <h3 className="text-white font-medium text-lg tracking-widest mb-2">极强的自驱力与学习力</h3>
                    <p className="text-sm md:text-base leading-relaxed text-gray-400 font-light">
                      面对行业技术的快速迭代，能保持极高的敏感度并在业余时间主动钻研，迅速将其转化为生产力。工作态度积极、责任心强。
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>

          {/* 右侧：个人照片区域 (升级为视频 + 电视开屏动效) */}
          <div 
            // 替换成这样（把 -mt-6 改为 -mt-40，加大向上拉的力度）：
className={`w-full lg:w-full -mt-20 lg:mt-0 relative aspect-square rounded-2xl overflow-hidden shadow-2xl border border-gray-100/10 transition-all duration-700 ease-out origin-center ${
              isVisible 
                ? 'scale-y-100 scale-x-100 opacity-100 brightness-100 blur-0' 
                : 'scale-y-0 scale-x-50 opacity-0 brightness-200 blur-md'
            }`}
            style={{ 
              transitionDelay: isVisible ? '1800ms' : '0ms' // 👈 等“王涛”出现后的第 1.8 秒准时开机！离开时瞬间重置
            }}
          >
            <video
              src="https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/avatar.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover rounded-2xl"
              style={{ mixBlendMode: 'plus-lighter' }}
            />
          </div>

        </div> {/* 👈 新增这一行：关上最外层的左右布局大网格盒子！ */}

      </section> {/* 👈 现在的第 295 行被挤下来了 */}

   {/* 第3屏：核心作品展示 (极简高端画廊版) */}
<section ref={section3Ref} className="relative h-screen w-full snap-start flex items-center justify-center bg-[#050505] overflow-hidden z-10 px-6 lg:px-12">

  {/* 🌌 新增：与整个网站呼应的深邃氛围光晕 */}
  <div className="absolute top-1/2 -left-32 -translate-y-1/2 w-[600px] h-[600px] bg-[#2b5a8d]/10 rounded-full blur-[150px] pointer-events-none"></div>
  <div className="absolute top-1/2 -right-32 -translate-y-1/2 w-[800px] h-[800px] bg-purple-900/10 rounded-full blur-[150px] pointer-events-none"></div>

  <div className="max-w-[1600px] w-full h-full grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pointer-events-auto z-10">
          
          <div className="lg:col-span-5 z-30 space-y-4 md:space-y-6 mt-24 lg:mt-0 flex flex-col items-center lg:items-start text-center lg:text-left lg:ml-24 xl:ml-56"
            style={{
              opacity: isSection3Visible ? 1 : 0,
              transform: isSection3Visible ? 'translateY(0)' : 'translateY(60px)',
              transition: 'all 1.2s cubic-bezier(0.16, 1, 0.3, 1)'
            }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-[4.5rem] font-bold text-white leading-[1.1] tracking-wide whitespace-nowrap drop-shadow-2xl">
        这就是我的
        <br />
        {/* 在这里加入了你最爱的深海蓝到冰蓝渐变 */}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2b5a8d] to-[#c1e2ff]">
          作品展映
        </span>
      </h2>
      <p className="text-gray-400 text-lg md:text-xl font-light">
        点击卡牌查看对应作品
      </p>
          </div>

          <div className="lg:col-span-7 relative w-full h-[350px] lg:h-[900px] flex items-center justify-center lg:justify-end z-20 mt-8 lg:mt-0 lg:translate-x-[300px] lg:-translate-y-[230px]">
  <div className="w-full h-full flex items-center justify-center lg:justify-end"
              style={{
                opacity: isSection3Visible ? 1 : 0,
                transform: isSection3Visible ? 'translateX(0)' : 'translateX(800px)',
                transition: 'all 1.5s cubic-bezier(0.16, 1, 0.3, 1) 0.15s'
              }}
            >
              <div className="transform scale-[0.35] sm:scale-50 lg:scale-100 origin-top lg:origin-right w-full flex justify-center items-start lg:items-center mt-10 lg:mt-0"></div>
              <CardSwap cardDistance={80} verticalDistance={125} delay={5000} pauseOnHover={true}>
                
                {/* 🎴 第 3 层 - 影视制作 */}
                <Card style={{ width: '1344px', height: '756px', maxWidth: 'none', flexShrink: 0 }} className="bg-transparent rounded-xl shadow-[0_40px_100px_rgba(0,0,0,0.95)]">
                  <div className="relative w-full h-full rounded-xl overflow-hidden group cursor-pointer bg-white/20" onMouseMove={handleMouseMove} onClick={() => setActivePortal({ title: 'TAO · 影视制作', content: ColorGradingContent, dotColor: 'bg-orange-500', shadowColor: 'shadow-[0_0_15px_rgba(249,115,22,0.8)]' })}>
                    <div className="absolute inset-0 z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{ background: 'radial-gradient(1200px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(167,139,250,1) 0%, rgba(59,130,246,1) 15%, rgba(6,182,212,0.7) 40%, transparent 80%)' }} />
                    <div className="absolute inset-[3px] z-10 flex flex-col rounded-[10px] overflow-hidden bg-[#0a0a0a]">
                      <div className="flex items-center px-6 py-5 border-b border-white/5 bg-[#111]">
                        <div className="w-4 h-4 rounded-full bg-orange-500 mr-4 shadow-[0_0_12px_rgba(249,115,22,0.8)] animate-pulse"></div>
                        <span className="text-white/90 text-xl font-medium tracking-widest">TAO · 影视制作</span>
                      </div>
                      <div className="flex-1 relative bg-black group/video">
                        {ColorGradingContent}
                      </div>
                    </div>
                  </div>
                </Card>

                {/* 🎴 第 2 层 - 特效制作 */}
                <Card style={{ width: '1344px', height: '756px', maxWidth: 'none', flexShrink: 0 }} className="bg-transparent rounded-xl shadow-[0_40px_100px_rgba(0,0,0,0.95)]">
                  <div className="relative w-full h-full rounded-xl overflow-hidden group cursor-pointer bg-white/20" onMouseMove={handleMouseMove} onClick={() => setActivePortal({ title: 'TAO · 特效制作', content: VFXContent, dotColor: 'bg-emerald-500', shadowColor: 'shadow-[0_0_15px_rgba(16,185,129,0.8)]' })}>
                    <div className="absolute inset-0 z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{ background: 'radial-gradient(1200px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(167,139,250,1) 0%, rgba(59,130,246,1) 15%, rgba(6,182,212,0.7) 40%, transparent 80%)' }} />
                    <div className="absolute inset-[3px] z-10 flex flex-col rounded-[10px] overflow-hidden bg-[#0a0a0a]">
                      <div className="flex items-center px-6 py-5 border-b border-white/5 bg-[#111]">
                        <div className="w-4 h-4 rounded-full bg-emerald-500 mr-4 shadow-[0_0_12px_rgba(16,185,129,0.8)] animate-pulse"></div>
                        <span className="text-white/90 text-xl font-medium tracking-widest">TAO · 特效制作</span>
                      </div>
                      <div className="flex-1 relative bg-black group/video">
                        {VFXContent}
                      </div>
                    </div>
                  </div>
                </Card>

                {/* 🎴 第 1 层 - 视觉设计 */}
                <Card style={{ width: '1344px', height: '756px', maxWidth: 'none', flexShrink: 0 }} className="bg-transparent rounded-xl shadow-[0_40px_100px_rgba(0,0,0,0.95)]">
                  <div className="relative w-full h-full rounded-xl overflow-hidden group cursor-pointer bg-white/20" onMouseMove={handleMouseMove} onClick={() => setActivePortal({ title: 'TAO · 视觉设计', content: VisualDesignContent, dotColor: 'bg-blue-500', shadowColor: 'shadow-[0_0_15px_rgba(59,130,246,0.8)]' })}>
                    <div className="absolute inset-0 z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{ background: 'radial-gradient(1200px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(167,139,250,1) 0%, rgba(59,130,246,1) 15%, rgba(6,182,212,0.7) 40%, transparent 80%)' }} />
                    <div className="absolute inset-[3px] z-10 flex flex-col rounded-[10px] overflow-hidden bg-[#0a0a0a]">
                      <div className="flex items-center px-6 py-5 border-b border-white/5 bg-[#111]">
                        <div className="w-4 h-4 rounded-full bg-blue-500 mr-4 shadow-[0_0_12px_rgba(59,130,246,0.8)] animate-pulse"></div>
                        <span className="text-white/90 text-xl font-medium tracking-widest">TAO · 视觉设计</span>
                      </div>
                      <div className="flex-1 relative bg-black group/video">
                        {VisualDesignContent}
                      </div>
                    </div>
                  </div>
                </Card>

              </CardSwap>
            </div>
          </div>
        </div>

        {/* ========================================================= */}
        {/* 🌀 终极传送门：加入 PixelCard 交互与无缝空间跃迁 */}
        {/* ========================================================= */}
        <div
          className={`fixed inset-0 z-[100] flex items-center justify-center transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${
            activePortal ? 'opacity-100 pointer-events-auto backdrop-blur-xl bg-black/80' : 'opacity-0 pointer-events-none'
          }`}
          onClick={() => !isNavigating && setActivePortal(null)}
        >
          <div
            // 🚨 核心动画：如果是正在跳转(isNavigating)，则极速放大并化为虚无！
            className={`relative w-[90vw] h-[85vh] max-w-[1600px] transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${
              isNavigating 
                ? 'scale-110 opacity-0 blur-2xl pointer-events-none' // 离场：加速冲向镜头并消散
                : activePortal 
                  ? 'scale-100 translate-y-0 opacity-100 delay-100' // 正常展开
                  : 'scale-95 translate-y-20 opacity-0' // 进场前
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative w-full h-full rounded-2xl overflow-hidden bg-white/20 shadow-[0_0_120px_rgba(59,130,246,0.2)] group/portal" onMouseMove={handleMouseMove}>
              
              <div 
                className="absolute inset-0 z-0 opacity-0 group-hover/portal:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{ background: 'radial-gradient(1500px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(167,139,250,1) 0%, rgba(59,130,246,1) 15%, rgba(6,182,212,0.7) 40%, transparent 80%)' }}
              />

              <div className="absolute inset-[3px] z-10 flex flex-col rounded-[14px] overflow-hidden bg-[#0a0a0a]">
                
                {/* 标题栏 */}
                <div className="flex items-center justify-between px-8 py-6 border-b border-white/10 bg-[#111] shrink-0">
                  <div className="flex items-center">
                    <div className={`w-5 h-5 rounded-full mr-5 animate-pulse ${activePortal?.dotColor} ${activePortal?.shadowColor}`}></div>
                    <span className="text-white text-2xl font-bold tracking-widest">{activePortal?.title}</span>
                  </div>
                  <button onClick={() => setActivePortal(null)} className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-all duration-300 hover:rotate-90">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                  </button>
                </div>
                
               {/* 🚀 内容区：注入 PixelCard 与点击跳转事件 */}
                <div className="flex-1 bg-black relative group/jump cursor-pointer overflow-hidden" onClick={handleProjectJump}>
                  
                  <style>{`
                    .pixel-nuke-wrapper > * {
                      width: 100% !important;
                      height: 100% !important;
                      max-width: none !important;
                      aspect-ratio: auto !important;
                      border: none !important;
                      border-radius: 0 !important;
                      margin: 0 !important;
                    }
                    .force-transparent-bg > div {
                      background-color: transparent !important;
                    }
                  `}</style>

                  <div className="absolute inset-0 w-full h-full pixel-nuke-wrapper">
                    <PixelCard variant="blue" gap={10}>
                      {/* 🚨 核心升级：加入了 group-hover/jump 的毛玻璃模糊 (blur-md)、变暗 (opacity-30) 和轻微后退 (scale-[0.98]) 效果！ */}
                      <div className="absolute inset-0 w-full h-full pointer-events-none force-transparent-bg transition-all duration-700 ease-out group-hover/jump:blur-[12px] group-hover/jump:opacity-30 group-hover/jump:scale-[0.98]">
                        {activePortal?.content}
                      </div>
                    </PixelCard>
                  </div>

                  {/* 💡 悬停时的“点击进入”视觉引导 */}
                  <div className="absolute inset-0 bg-black/0 group-hover/jump:bg-black/40 transition-all duration-300 flex items-center justify-center pointer-events-none z-50">
                     <div className="opacity-0 group-hover/jump:opacity-100 translate-y-8 group-hover/jump:translate-y-0 transition-all duration-500 bg-white/10 backdrop-blur-md border border-white/20 text-white px-10 py-4 rounded-full font-mono text-lg tracking-[0.2em] flex items-center gap-3 shadow-[0_0_40px_rgba(255,255,255,0.2)]">
                       <span>CLICK TO EXPLORE</span>
                       <svg className="w-6 h-6 animate-[bounce_1s_infinite]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                     </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 第4屏 & 第5屏正常滚动容器 */}
      <div className="snap-start bg-white w-full">
        
        {/* ================= 最后一屏：联系方式 ================= */}
        <section className="relative h-screen w-full snap-start flex flex-col items-center justify-center bg-[#050505] text-white px-6 overflow-hidden z-10">
          
          {/* 氛围光晕 */}
          <div className="absolute top-1/4 -left-20 w-96 h-96 bg-purple-600/15 rounded-full blur-[120px] pointer-events-none"></div>
          <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-blue-600/15 rounded-full blur-[120px] pointer-events-none"></div>

          <div className="max-w-5xl w-full relative z-10 text-center space-y-12 mt-24 lg:mt-0">
            
            {/* 标题 */}
            <div className="space-y-4">
              <h2 className="text-fuchsia-500 font-mono tracking-[0.5em] uppercase text-xs">Get in touch</h2>
              <h1 className="text-5xl md:text-8xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-[#2b5a8d] via-purple-500 to-[#c1e2ff] bg-[length:200%_auto] animate-[gradientFlow_5s_ease_infinite] uppercase pb-2">
                Let's Create.
              </h1>
            </div>

            {/* 信息网格 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-16">
              {/* 手机号 */}
              <div className="group p-8 rounded-3xl border border-white/5 bg-white/[0.02] backdrop-blur-xl hover:border-white/20 transition-all duration-500 hover:-translate-y-2">
                <p className="text-neutral-500 font-mono text-xs uppercase tracking-widest mb-4">电话</p>
                <p className="text-xl md:text-2xl font-bold tracking-tight group-hover:text-fuchsia-500 transition-colors">178-2800-3135</p>
              </div>

              {/* 邮箱 */}
              <div className="group p-8 rounded-3xl border border-white/5 bg-white/[0.02] backdrop-blur-xl hover:border-white/20 transition-all duration-500 hover:-translate-y-2">
                <p className="text-neutral-500 font-mono text-xs uppercase tracking-widest mb-4">邮箱</p>
                <p className="text-xl md:text-xl font-bold tracking-tight group-hover:text-blue-500 transition-colors">598267428@qq.com</p>
              </div>

              {/* 微信 */}
              <div className="group p-8 rounded-3xl border border-white/5 bg-white/[0.02] backdrop-blur-xl hover:border-white/20 transition-all duration-500 hover:-translate-y-2">
                <p className="text-neutral-500 font-mono text-xs uppercase tracking-widest mb-4">微信</p>
                <p className="text-xl md:text-2xl font-bold tracking-tight group-hover:text-purple-500 transition-colors">taobabiwxm</p>
              </div>
            </div>

            {/* 底部版权信息 */}
            <div className="pt-20 opacity-30 font-mono text-[10px] tracking-[0.4em] uppercase flex flex-col items-center gap-4">
                <p>Based in Shanghai, China</p>
                <div className="w-px h-12 bg-gradient-to-b from-white to-transparent"></div>
                <p>© 2026 TAO VISION ALL RIGHTS RESERVED</p>
            </div>
          </div>
          {/* 流动渐变动画引擎 */}
          <style>{`
            @keyframes gradientFlow {
              0% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
              100% { background-position: 0% 50%; }
            }
          `}</style>
        </section>

        
      </div>

      {/* 图片放大预览遮罩层 */}
      {activeImage && (
        <div 
          className="fixed inset-0 bg-white/95 backdrop-blur-sm z-50 flex items-center justify-center p-8 cursor-zoom-out transition-all duration-300"
          onClick={() => setActiveImage(null)}
        >
          <div className="relative w-[75vw] h-[75vh] flex items-center justify-center bg-gray-200 rounded-lg shadow-2xl overflow-hidden">
            <span className="text-gray-500 text-lg text-center">
              {activeImage} <br/> [ 约束在 75vw / 75vh 内, 保持原图比例 ]
            </span>
          </div>
        </div>
      )}

    </div>
  );
}